export { default } from './GenerateDate.js';